
import { useQuery } from '@tanstack/react-query';
import { sellerServices } from '../services/seller.service';

/**
 * Reusable API error parser
 */
const parseApiError = (error) => {
  return {
    message:
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      'Something went wrong',

    status: error?.response?.status || 500,

    errors: error?.response?.data?.errors || [],
  };
};

/**
 * Get all sellers
 */
export const useSellers = (filters) => {
  return useQuery({
    queryKey: ['sellers', filters],

    queryFn: async () => {
      try {
        return await sellerServices.getSellers(filters);
      } catch (error) {
        throw parseApiError(error);
      }
    },

    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes

    placeholderData: (previousData) => previousData,

    retry: 1,
  });
};